export default {
  name: 'Application',
  data() {
    return {
      select: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      editItem: null,
      photo: [],
      loading: false,
      showDetails: false,
      order: null,
      page: 1,
    };
  },
  computed: {
    items() {
      return this.$store.state.applications.items;
    },
    pagesCount() {
      // eslint-disable-next-line no-underscore-dangle
      return this.$store.state.applications._meta.pageCount;
    },
  },
  methods: {
    loadApplications() {
      this.$store.dispatch('applications/list', {
        page: this.page,
      });
    },
    goToSales() {
      this.$router.push('/sales');
    },
    submit() {
      this.loading = true;
      this.$store
        .dispatch('applications/update', {
          order_id: this.editItem.id,
          photo: this.photo,
        })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.photo = [];
          this.editItem = null;
          this.loadApplications();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item, status) {
      this.loading = true;
      this.$store
        .dispatch('applications/changeStatus', { order_id: item.id, status })
        .then(() => {
          this.loadApplications();
          this.$store.dispatch('GetCounters');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    OnChat(item) {
      this.$router.push(`/chat/${item.id}`);
    },
    ShowDetails(order) {
      this.order = order;
      this.showDetails = true;
    },
    CloseDetails() {
      this.order = null;
      this.showDetails = false;
    },
    OrderMsgCnt(order) {
      let executorMsgCount = 0;

      order.ordersToExecutors?.forEach((item) => {
        executorMsgCount += item.executor_msg_cnt;
      });
      return executorMsgCount > 0 ? `${executorMsgCount}` : '';
    },
    // eslint-disable-next-line consistent-return
    GetChatColor(status) {
      if (status === 'approved' || status === 'setExecutor') {
        return 'blue';
      }
      return 'gray';
    },
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Заявки на монтаж');
    this.loadApplications();
  },
};
